/* This file is autogenerated, see readme.md for instructions */
import DownloadSvgIcon from '@bloomreach/banana-theme/icons/download.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DownloadIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DownloadSvgIcon />
    </Icon>
  );
});

DownloadIcon.displayName = 'DownloadIcon';

export default DownloadIcon;
